

(function ($) {
    "use strict";

    $(function () {


        /* Iframe modals like panoramictour or virtual flatpicker */
        $(".iframe-modal").iziModal({
            history: false,
            iframe: true,
            fullscreen: true,
            headerColor: '#03334f',
            openFullscreen: false,
            focusInput: false,
            appendTo: '.modals-wrapper',
            width: 977,
            iframeHeight: 555,
            bodyOverflow: true,
            radius: 0,
            onOpening: function () {
                $('.iframe-modal').find('iframe').attr('allowfullscreen', 'allowfullscreen');
            }
        });

    });


})(jQuery);


